export default __webpack_public_path__ + "static/Toronto-55a87499e6b0d639ede74d409b732295.webp";